import { useQuery } from '@tanstack/react-query';
import { api } from '../lib/apiClient';
import { templateKeys } from './useTemplates';
import type { TemplateCategory } from '../../lib/types/template.types';

/**
 * Fetch all template categories
 *
 * @returns Query result with categories list
 *
 * @example
 * const { data: categories } = useCategories();
 */
export function useCategories() {
  return useQuery({
    queryKey: templateKeys.categories(),
    queryFn: async () => {
      const { data } = await api.get<TemplateCategory[]>('/api/templates/categories');
      return data;
    },
    staleTime: 1000 * 60 * 5, // 5 minutes - categories change rarely
  });
}
